import type { HashicorpCloudResourcemanagerRole } from '@clients/cloud-resource-manager';
import type { IamRoleLocation } from '../types/iam-role-location';

import { parseRoleId } from 'manage-access/utils/parse-role-id';

export function createRoleLocationFilter({
  filters,
  roles,
}: {
  filters: {
    search: string;
    serviceIds: Array<string>;
    scopeIds: Array<string>;
    scopeTypes: Array<string>;
  };
  roles: Array<HashicorpCloudResourcemanagerRole>;
}) {
  const { search, serviceIds, scopeIds, scopeTypes } = filters;

  return function (roleLocation: IamRoleLocation) {
    const { roleId, link } = roleLocation;
    const { service } = parseRoleId(roleId);
    const role = roles.find((role) => role.id === roleId);

    const scopeIdMatch =
      scopeIds?.length && typeof link?.id === 'string'
        ? scopeIds.includes(link.id)
        : true;
    const scopeTypeMatch =
      scopeTypes?.length && typeof link?.type === 'string'
        ? scopeTypes.includes(link.type)
        : true;
    const roleIdMatch =
      typeof search === 'string'
        ? roleId?.includes(search.toLowerCase())
        : true;
    const roleTitleMatch =
      typeof search === 'string' && typeof role?.title === 'string'
        ? role.title.toLowerCase().includes(search.toLowerCase())
        : true;
    const roleDescriptionMatch =
      typeof search === 'string' && typeof role?.description === 'string'
        ? role.description.toLowerCase().includes(search.toLowerCase())
        : true;
    const serviceIdMatch =
      serviceIds?.length && typeof service === 'string'
        ? serviceIds.includes(service)
        : true;
    return (
      scopeIdMatch &&
      scopeTypeMatch &&
      (roleIdMatch ||
        (role && roleTitleMatch) ||
        (role && roleDescriptionMatch)) &&
      serviceIdMatch
    );
  };
}

export default createRoleLocationFilter;
